import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 pt-2 gap-6 h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-montserrat text-2xl" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Latest Public Graph")
], -1)
const _hoisted_3 = { class: "w-full h-screen bg-white rounded-md pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GraphList = _resolveComponent("GraphList", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GraphList)
      ])
    ])
  ]))
}